import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import { CatalogoService } from '../../../../service/CatalogoService';
import * as generic from '../../../../components/Generico';
import { ProveedorPnService } from '../../../../service/trust/ProveedorPnService';
import { InformacionGeneral } from '../../../../models/trust/proveedor/InformacionGeneral';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';
import { InputActividadEconomica } from '../../../../components/ui/Formularios/InputActividadEconomica';

export const InfoGeneral = ({ toast, id, proveedor, permss, catalogos, handleNext, nuevoProveedor, soloLectura }) => {

    const omodel = new InformacionGeneral();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue, clearErrors, watch, trigger } = useForm({ defaultValues, shouldTrim: true, mode: 'onTouched' });
    const proveedorServicio = new ProveedorPnService();
    const catalogoService = new CatalogoService();
    const { inDrop, inText, inCalendar, inArea, inNumber } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [ecuador, setEcuador] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [esRuc, setEsRuc] = useState(false);
    const [esCedula, setEsCedula] = useState(false);

    const fechaNacimiento = watch('fecha_nacimiento');

    useEffect(() => {
        if (fechaNacimiento) {
            // Llamamos directamente a la función mejorada de tu generic
            const edad = generic.calcularEdad(fechaNacimiento);
            setValue('edad', edad);
        } else {
            setValue('edad', null);
        }
    }, [fechaNacimiento, setValue]);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const onSubmit = (data) => {
        setIsSaving(true);
        data.ec = catalogos?.ecuador;
        data.fecha = generic.dateToString(data.fecha);
        data.fecha_nacimiento = generic.dateToString(data.fecha_nacimiento);
        data.fecha_inicio_actividad_profesional = generic.dateToString(data.fecha_inicio_actividad_profesional);
        data.seccion = 'seccion1';

        if (id == null) {
            proveedorServicio.newProveedor(data).then(res => {
                nuevoProveedor(res.data);
                generic.funcSuccess(res, toast);
                handleNext();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => setIsSaving(false));
        } else {
            data.id = id;
            proveedorServicio.editarProveedor(data).then(res => {
                nuevoProveedor(res.data);
                generic.funcSuccess(res, toast);
                handleNext();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => setIsSaving(false));
        }
    }

    const editFicha = () => {
        setIsLoading(true);
        proveedorServicio.consultarProveedor(id ?? 0, { seccion: 'seccion1' }).then(res => {
            const cats = catalogos;
            const _prov = res.data.proveedor;

            if (!_prov) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }

            if (res.data.ciudades !== undefined) {
                setCiudades(res.data.ciudades);
            }

            setEcuador(_prov.pais_residencia?.cat_id === cats?.ecuador?.cat_id);

            _prov.fecha = generic.stringToDate(_prov.fecha);
            _prov.fecha_nacimiento = generic.stringToDate(_prov.fecha_nacimiento);
            _prov.fecha_inicio_actividad_profesional = generic.stringToDate(_prov.fecha_inicio_actividad_profesional);

            setEsRuc(_prov.tipo_identificacion?.cat_id === cats?.ruc?.cat_id);
            setEsCedula(_prov.tipo_identificacion?.cat_id === cats?.cedula?.cat_id);

            nuevoProveedor({ id: _prov.id, nemonico: _prov.nemonico });
            reset(generic.renewValues(_prov, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangePais = (e) => {
        setEcuador(e.value?.cat_id === catalogos?.ecuador?.cat_id);
        setValue('provincia_residencia', null);
        setValue('ciudad_residencia', null);
        setCiudades([]);
        if (getValues('telefono')) {
            trigger('telefono');
        }
        if (getValues('celular')) {
            trigger('celular');
        }
    }

    const onChangeProvincia = (e) => {
        setValue('ciudad_residencia', null);
        if (!e?.value) { setCiudades([]); return; }
        catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudades(res.data));
    }

    const onChangeTipo = (e) => {
        setEsRuc(e.value?.cat_id === catalogos?.ruc?.cat_id);
        setEsCedula(e.value?.cat_id === catalogos?.cedula?.cat_id);
        clearErrors('identificacion');
    }

    const tipoDoc = esRuc ? 'IDEN_RUC' : esCedula ? 'IDEN_CEDULA' : null;

    const reglaValidacion = (val) => {
        if (!tipoDoc) return true;
        return generic.validarIdentificacionEcuador(val, tipoDoc) || `${esRuc ? 'RUC' : 'Cédula'} incorrecto`;
    };

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
            <Panel header={generic.renderPanelHeader('A', 'INFORMACIÓN GENERAL', 'pi pi-briefcase')} className="panel-ficha shadow-1">
                <div className="formgrid grid">
                    {inCalendar('fecha', {}, 3)}
                    {inDrop('tipo_estructura', catalogos?.tipo_estructura, { lab: omodel.optionLabel }, 3)}

                    {inText('apellido_paterno', { icon: 'pi pi-user' }, 3)}
                    {inText('apellido_materno', { icon: 'pi pi-user' }, 3)}
                    {inText('nombres', { icon: 'pi pi-user' }, 3)}

                    {inDrop('tipo_identificacion', catalogos?.tipo_identificacion, { lab: omodel.optionLabel, chn: onChangeTipo }, 3)}
                    {inText('identificacion', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 3)}
                    {inCalendar('fecha_nacimiento', {}, 3)}
                    {inNumber('edad', 0, false, { disabled: true }, 3)}

                    {inDrop('genero', catalogos?.genero, { lab: omodel.optionLabel }, 4)}
                    {inDrop('estado_civil', catalogos?.estado_civil, { lab: omodel.optionLabel }, 4)}
                    {inDrop('nacionalidad', catalogos?.nacionalidad, { lab: omodel.optionLabel }, 4)}

                    {inDrop('pais_residencia', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais }, ecuador ? 4 : 6)}
                    {ecuador ? (
                        <>
                            {inDrop('provincia_residencia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia }, 4)}
                            {inDrop('ciudad_residencia', ciudades, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('canton_residencia', { icon: 'pi pi-map-marker' }, 6)
                    )}

                    {inArea('direccion_residencia', 3, 100, 12)}

                    {inText('telefono', { icon: 'pi pi-phone', validate: generic.validarTelefonoDinamico(getValues, 'pais_residencia') }, 4)}
                    {inText('fax', { icon: 'pi pi-phone' }, 4)}
                    {inText('celular', { icon: 'pi pi-phone', validate: generic.validarTelefonoDinamico(getValues, 'pais_residencia') }, 4)}

                    {inText('email', { icon: 'pi pi-envelope', pattern: generic.VALIDACION_EMAIL }, 12)}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('B', 'ACTIVIDAD ECONÓMICA', 'pi pi-briefcase')} className="panel-ficha shadow-1">
                <div className="formgrid grid">
                    {inText('profesion', { icon: 'pi pi-user' }, 6)}
                    {inText('ruc', { icon: 'pi pi-id-card' }, 6)}

                    {inText('sector_economico', { icon: 'pi pi-briefcase' }, 6)}
                    {inNumber('ingreso_promedio', 2, true, {}, 6)}

                    <InputActividadEconomica name="actividad_economica" control={control} modelDef={omodel.model['actividad_economica']} disabled={soloLectura} col={12} />

                    {inCalendar('fecha_inicio_actividad_profesional', {}, 6)}
                </div>
            </Panel>

            <BottomActionBar layoutVersion="v2" onNext={handleNext} loading={isSaving} isReadOnly={soloLectura} />
        </form>
    );
}
